
export const parseTag = (metaID, metatag, metaValue, rgroup) => {
  let type;
  if (metatag.USER_DEFINED_VALUE[0] === 'CHECKBOX') type = 'CHECKBOX';
  else if (metatag.USER_DEFINED_VALUE[0] === 'RADIO') type = 'RADIO';
  else if (metatag.DISPLAY_API[0] === 'RICH' ||
    metatag.USER_DEFINED_VALUE[0] === 'RICH' ||
    metatag.USER_DEFINED_VALUE[0] === 'RICHTEXT') type = 'RICHTEXT';
  else type = metatag.TYPE[0].toUpperCase();

  return {
    id: metaID || metatag.TAG_ID || metatag.$.TAG_ID, // Metatag ID
    name: `${metatag.CATEGORY[0]}.${metatag.TAG_NAME[0]}`, // Metatag Name
    label: metatag.DISPLAY_VALUE[0] || metatag.TAG_NAME[0], // Metatag display
    type, // Metatag type
    lovList: metatag.LOV_LIST[0], // LOV List (if it exists)
    lovListId: metatag.LOV_CC_TAG_CC[0], // LOV List ID (if it exists)
    repeatingField: metatag.REPEATING_FIELDS[0] === 'S', // Simple repeating field (true/false)
    keywordDelim: metatag.RFIELD_DELIMETER[0],
    rgroup,
    maxLength: metatag.MAXLENGTH[0], // Metatag maximum length
    mandatory: metatag.MANDATORY[0] === 'T', // Metatag mandatory tag
    value: metaValue, // Value of this metatag as returned in image_query
    valueType: metatag.CORE_TYPE[0], // Type of the actual value (e.g varchar, keywords, date etc)
    defaultValue: metatag.DEFAULT_VALUE[0], // Default value, if exists
  };
};

export const parseMetatags = (metatags, metaValues, onlyExistingTags) => {
  const parsedData = [];
  let tag;
  let newValue = '';
  let metaID = '';
  let rTags = [];

  for (let i = 0; i < metatags.length; i++) {
    newValue = null;
    tag = Array.isArray(metatags[i]) ? metatags[i][0] : metatags[i];
    metaID = tag.TAG_ID || tag.$.TAG_ID;
    if (!onlyExistingTags || (onlyExistingTags && metaValues[metaID])) {
      if (tag.TYPE[0] === 'RGROUP' || tag.TYPE[0] === 'UMO_INPUT') { // Parsing repeating groups
        try {
          let rMeta = tag.RGROUP[0].META_TAG; // Extract children metatags
          if (!Array.isArray(rMeta)) rMeta = [rMeta];
          const rGroup = metaValues[metaID] && metaValues[metaID].rgroup
            ? metaValues[metaID].rgroup.mv : [];
          newValue = [];
          rTags = [];

          for (let k = 0; k < rMeta.length; k++) {
            rTags.push(parseTag(rMeta[k].TAG_ID, rMeta[k]));
          }

          for (let k = 0; k < rGroup.length; k++) { // Loop through metadata
            const pos = rGroup[k]['$'].p - 1;
            // Define an array for this position if it doesn't already exist
            if (!newValue[pos]) newValue[pos] = [];

            // Retrieve metatag data from the children metatags
            for (let j = 0; j < rMeta.length; j++) {
              if (rGroup[k]['$'].id === rMeta[j]['$'].TAG_ID) {
                newValue[pos].push(parseTag(rMeta[j].TAG_ID, rMeta[j], rGroup[k]['_']));
              }
            }
          }
        } catch (e) {
          // this.intl.formatMessage({ id: 'metaParseErrorMessage' });
          console.log(tag, e);
        }
      } else if (tag.REPEATING_FIELDS[0] === 'S') { // Parsing single repeating field
        newValue = [];
        if (metaValues[metaID]) { // if there is an existing value for that metatag
          if (metaValues[metaID].length > 0) {
            for (let k = 0; k < metaValues[metaID].length; k++) {
              newValue.push(metaValues[metaID][k].value);
            }
          }
        }
        // Parse regular meta values
      } else if (metaValues[metaID]) newValue = metaValues[metaID].value;
      else newValue = '';

      parsedData.push(parseTag(metaID, tag, newValue, rTags));
    }
  }
  return (parsedData);
};

/*
* @param metaValues - the metatag values returning for a umo in an image_query
* @param onlyExistingTags - return an object that contains metatags that have a value,
* and not empty ones
* */
export const parseMetaValues = (metadata, onlyExistingTags) => {
  const lookup = {};
  for (let i = 0; i < metadata.length; i++) {
    metadata[i].rgroup = metadata[i]._data.rgroup && metadata[i]._data.rgroup[0];
    if (!onlyExistingTags ||
      (onlyExistingTags && (metadata[i].value || metadata[i].text || metadata[i].rgroup))) {
      // If multiple values (i.e. Repeating fields), convert to an array.
      if (lookup[metadata[i].id]) {
        let arr = [];
        arr = arr.concat(lookup[metadata[i].id]);
        arr.push(metadata[i]);
        lookup[metadata[i].id] = arr;
      } else lookup[metadata[i].id] = metadata[i];
    }
  }
  return lookup;
};
